import { render, staticRenderFns } from "./personageOrder.vue?vue&type=template&id=65ca8f47&scoped=true&"
import script from "./personageOrder.vue?vue&type=script&lang=js&"
export * from "./personageOrder.vue?vue&type=script&lang=js&"
import style0 from "./personageOrder.vue?vue&type=style&index=0&id=65ca8f47&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca8f47",
  null
  
)

export default component.exports